import React, { FC } from "react";
import { AvatarGroup, Avatar } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { AnySchema } from "yup";

import { getAvatarPropsByName } from "@helpers";
import { useDraft } from "@hooks/useDraft";
import { useMultistepFormStore } from "@components/common/MultistepForm";

interface AvatarGroupDisplayProps {
  setValue: UseFormSetValue<{ [x: string]: AnySchema }>;
}

const AvatarGroupDisplay: FC<AvatarGroupDisplayProps> = ({ setValue }) => {
  const {
    formSettings: { formBasics },
  } = useMultistepFormStore();
  const { activeUsers } = useDraft({
    formId: formBasics.id,
    setValue,
  });

  return (
    <AvatarGroup max={4}>
      {activeUsers.map((user, index) => (
        <Avatar
          {...getAvatarPropsByName(user.lockedByUserName!)}
          key={`nav-avatar-${index}`}
        />
      ))}
    </AvatarGroup>
  );
};

export default AvatarGroupDisplay;
